import Star from './Star.js';

export default class ProductReviews {
  constructor(reviews, extraBaseClassName) {
    this.average = reviews?.average || 0;
    this.count = reviews?.count || 0;
    this.reviewsNode = document.createElement('div');
    this.extraBaseClassName = extraBaseClassName || '';

    this.init();
  }

  /**
   * Initialize ProductTile Reviews section
   */
  init() {
    this.reviewsNode.classList.add('product-card-c-basis__reviews');
    // Set extra base class if provided
    this.extraBaseClassName && this.reviewsNode.classList.add(`${this.extraBaseClassName}__product-card-reviews`);

    // Create stars container
    const starsContainer = document.createElement('div');
    starsContainer.classList.add('product-card-c-basis__reviews-stars');

    const numStars = this.average;

    // Exit early to leave the empty container
    if (!numStars) return;

    for (let i = 0; i < 5; i++) {
      const star = new Star();
      const remainder = numStars - i;

      if (remainder >= 1) {
        starsContainer.appendChild(star.setFullStar());
      } else if (remainder > 0) {
        const percent = remainder * 100;
        starsContainer.appendChild(star.setPartialStar(percent));
      } else {
        starsContainer.appendChild(star.setEmptyStar());
      }
    }
    // Add visually-hidden text alternative for star rating
    const ratingText = document.createElement('span');
    ratingText.classList.add('visually-hidden');
    ratingText.textContent = `${this.average} out of 5 stars`;
    starsContainer.appendChild(ratingText);

    this.reviewsNode.appendChild(starsContainer);

    // Create count span
    if (this.count > 0) {
      const countSpan = document.createElement('span');
      countSpan.classList.add('product-card-c-basis__reviews-count');
      countSpan.textContent = `(${this.count})`;
      countSpan.setAttribute('aria-label', `${this.count} reviews`);
      this.reviewsNode.appendChild(countSpan);
    }
  }
}
